import { render, staticRenderFns } from "./ItemLink.vue?vue&type=template&id=32180c39&"
import script from "./ItemLink.vue?vue&type=script&lang=ts&"
export * from "./ItemLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports